<div class="about"><div class="container">
    <div class="row">
        <div class="col-md-6">
            <div class="about-box1">
          <h1>Making online learning <br> more effective, simple, <br> and engaging</h1>
          <h3>Who are we</h3>
          <p>We are a group of experienced retail professionals whose mission is <br> to  help retailers and vendors grow their retail business by helping <br> themdevelop their People and Processes.
          </p>
          <p>We are a group of experienced retail professionals whose mission is <br> to  help retailers and vendors grow their retail business by helping <br> themdevelop their People and Processes.
          </p>
        </div></div>
        <div class="col-md-6">
          <div class="about-img-box">
      <img src="../../../assets/about/Group 14719.png" alt="">
     

      
          </div>
        </div>
      </div>
</div></div>

<div class="container"><div class="choose">
    <div class="row">
        <div class="col-md-6"><div class="choose-box">
            <img src="../../../assets/about/Group 14513.png" alt="">
            
        </div></div>
        <div class="col-md-6"><div class="choose-box ">
           
            <h2>Why Choose Ratailo?</h2>
            <p>We are a group of experienced retail professionals whose mission is <br> to  help retailers and vendors grow their retail business by helping <br> themdevelop their People and Processes.
            </p>
            <p>We are a group of experienced retail professionals whose mission is <br> to  help retailers and vendors grow their retail business by helping <br> themdevelop their People and Processes.
            </p>
        </div></div>

    </div>
</div></div>
<div class="values"><div class="container">
  <h1>Our Values</h1>
  <p>We strive to make our solutions:</p>
  <div class="row">
    <div class=" col-4  col-lg-2">
      <div class="value-box">
        <img src="../../../assets/about/Group 16335.png" alt="">
        <h3>Impactful</h3>
        <p>In terms of business <br>
          results and ROI</p>
      </div>
    </div>
    <div class=" col-4  col-lg-2">
      <div class="value-box">
        <img src="../../../assets/about/Group 16338.png" alt="">
        <h3>Trusted</h3>
        <p>In terms of business <br>
          results and ROI</p>
      </div>
    </div>
    <div class=" col-4  col-lg-2">
      <div class="value-box">
        <img src="../../../assets/about/Group 16364.png" alt="">
        <h3>Relevant</h3>
        <p>In terms of business <br>
          results and ROI</p>
      </div>
    </div>
    <div class=" col-4  col-lg-2">
      <div class="value-box">
        <img src="../../../assets/about/Group 18366.png" alt="">
        <h3>Effective</h3>
        <p>In terms of business <br>
          results and ROI</p>
      </div>
    </div>
    <div class=" col-4  col-lg-2">
      <div class="value-box">
        <img src="../../../assets/about/Group 9101.png" alt="">
        <h3>Agile</h3>
        <p>In terms of business <br>
          results and ROI</p>
      </div>
    </div>
    <div class=" col-4  col-lg-2">
      <div class="value-box">
        <img src="../../../assets/about/Group 16376.png" alt="">
        <h3>Tailored</h3>
        <p>In terms of business <br>
          results and ROI</p>
      </div>
    </div>
  </div>
</div></div>

<div class="container"><div class="diff">
  <div class="row">
    <div class="col-md-6"><div class="diff-box">
      <h1>What makes us different?</h1>
      <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod <br> tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero <br> eos et accusam et justo duo dolores et ea rebum.
      </p>
      <button>Get in touch</button>
    </div></div>
    <div class="col-md-6">
      <div class="diff-img-box">
        <img src="../../../assets/about/Group 14886.png" alt="">
      </div>
    </div>
  </div>
</div>
</div>
<div class="team"><div class="container">
  <h1>Our Team</h1>
  <p>Drive visibility into performance and work toward common goals across the organization <br>
    with transparency and accountability
    </p>
    <div class="row">
      <div class="col-md-3">
        <div class="team-box">
          <img src="../../../assets/about/brooke-cagle-4gfbg7IulGA-unsplash.png" alt="">
        </div>
      </div>
      <div class="col-md-3">
        <div class="team-box">
          <img src="../../../assets/about/emile-guillemot-LSP9Tpavbms-unsplash.png" alt="">
        </div>
      </div>
      <div class="col-md-3">
        <div class="team-box">
          <img src="../../../assets/about/harishan-kobalasingam-8PMvB4VyVXA-unsplash (1).png" alt="">
        </div>
      </div>
      <div class="col-md-3">
        <div class="team-box">
          <img src="../../../assets/about/imansyah-muhamad-putera-n4KewLKFOZw-unsplash.png" alt="">
        </div>
      </div>
      <div class="col-md-3">
        <div class="team-box">
          <img src="../../../assets/about/imansyah-muhamad-putera-n4KewLKFOZw-unsplash.png" alt="">   
             </div>
      </div>
      <div class="col-md-3">
        <div class="team-box">
          <img src="../../../assets/about/emile-guillemot-LSP9Tpavbms-unsplash.png" alt="">
                </div>
      </div>
      <div class="col-md-3">
        <div class="team-box">
          <img src="../../../assets/about/harishan-kobalasingam-8PMvB4VyVXA-unsplash (1).png" alt="">
        </div>
      </div>
      <div class="col-md-3">
        <div class="team-box">
          <img src="../../../assets/about/brooke-cagle-4gfbg7IulGA-unsplash.png" alt="">
        </div>
      </div>
    </div>
</div></div>

<div class="container"><div class="customer">
  <h1>Some of our Happy Customers</h1>
  <img src="../../../assets/Group 9192.png" alt="">
  
  </div></div>

  <div class="info"><div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="info-box">
          <h1>Work for a company that <br> cares about you</h1>
    <p>We have space in our nest. <br> 
      Do you want to make simple solutions for complex problems? <br> 
      Then the Support Retailo are your feathered friends. We will make <br> sure that you feel part of our team. <br> 
      Our lunches, BBQs, and Friday afternoon drinks are a good way to get to<br>  know each other. Interested? <br> 
      Get in touch: jobs@retailo.com!</p>

      <button>Check Available Vacancies</button>
        </div>
      </div>
      <div class="col-md-6">
        <div class="info-img-box">
          <img src="../../../assets/about/Group 19311.png" alt="">
        </div>
      </div>
    </div>
    
  </div></div>